interface ColorValue {
    name: string;
    value: string;
}

const colors: ColorValue[] = [
    {
        name: 'amethyst-100',
        value: 'var(--color-amethyst-100, #ede1fa)',
    },
    {
        name: 'amethyst-200',
        value: 'var(--color-amethyst-200, #d8bef4)',
    },
    {
        name: 'amethyst-300',
        value: 'var(--color-amethyst-300, #c196ed)',
    },
    {
        name: 'amethyst-400',
        value: 'var(--color-amethyst-400, #ac73e7)',
    },
    {
        name: 'amethyst-500',
        value: 'var(--color-amethyst-500, #9952e0)',
    },
    {
        name: 'amethyst-600',
        value: 'var(--color-amethyst-600, #813ec3)',
    },
    {
        name: 'amethyst-700',
        value: 'var(--color-amethyst-700, #6a2da6)',
    },
    {
        name: 'amethyst-800',
        value: 'var(--color-amethyst-800, #541f89)',
    },
    {
        name: 'amethyst-900',
        value: 'var(--color-amethyst-900, #40136c)',
    },
    {
        name: 'blue-100',
        value: 'var(--color-blue-100, #e3f2ff)',
    },
    {
        name: 'blue-200',
        value: 'var(--color-blue-200, #bbdeff)',
    },
    {
        name: 'blue-300',
        value: 'var(--color-blue-300, #75baff)',
    },
    {
        name: 'blue-400',
        value: 'var(--color-blue-400, #42a1ff)',
    },
    {
        name: 'blue-500',
        value: 'var(--color-blue-500, #0f87ff)',
    },
    {
        name: 'blue-600',
        value: 'var(--color-blue-600, #007af5)',
    },
    {
        name: 'blue-700',
        value: 'var(--color-blue-700, #0066cc)',
    },
    {
        name: 'blue-800',
        value: 'var(--color-blue-800, #004d99)',
    },
    {
        name: 'blue-900',
        value: 'var(--color-blue-900, #002f5f)',
    },
    {
        name: 'blueviolet-100',
        value: 'var(--color-blueviolet-100, #e9e7fe)',
    },
    {
        name: 'blueviolet-200',
        value: 'var(--color-blueviolet-200, #cfcafc)',
    },
    {
        name: 'blueviolet-300',
        value: 'var(--color-blueviolet-300, #a79efa)',
    },
    {
        name: 'blueviolet-400',
        value: 'var(--color-blueviolet-400, #877bf8)',
    },
    {
        name: 'blueviolet-500',
        value: 'var(--color-blueviolet-500, #6758f6)',
    },
    {
        name: 'blueviolet-600',
        value: 'var(--color-blueviolet-600, #5547d7)',
    },
    {
        name: 'blueviolet-700',
        value: 'var(--color-blueviolet-700, #4438b8)',
    },
    {
        name: 'blueviolet-800',
        value: 'var(--color-blueviolet-800, #352b99)',
    },
    {
        name: 'blueviolet-900',
        value: 'var(--color-blueviolet-900, #271f7a)',
    },
    {
        name: 'bubblegum-100',
        value: 'var(--color-bubblegum-100, #ffe5fb)',
    },
    {
        name: 'bubblegum-200',
        value: 'var(--color-bubblegum-200, #ffccf7)',
    },
    {
        name: 'bubblegum-300',
        value: 'var(--color-bubblegum-300, #ffa6f1)',
    },
    {
        name: 'bubblegum-400',
        value: 'var(--color-bubblegum-400, #ff86eb)',
    },
    {
        name: 'bubblegum-500',
        value: 'var(--color-bubblegum-500, #ff66e6)',
    },
    {
        name: 'bubblegum-600',
        value: 'var(--color-bubblegum-600, #e746cd)',
    },
    {
        name: 'bubblegum-700',
        value: 'var(--color-bubblegum-700, #d02bb4)',
    },
    {
        name: 'bubblegum-800',
        value: 'var(--color-bubblegum-800, #b8149c)',
    },
    {
        name: 'bubblegum-900',
        value: 'var(--color-bubblegum-900, #a10286)',
    },
    {
        name: 'clay-100',
        value: 'var(--color-clay-100, #fbece4)',
    },
    {
        name: 'clay-200',
        value: 'var(--color-clay-200, #e7c6b6)',
    },
    {
        name: 'clay-300',
        value: 'var(--color-clay-300, #d69370)',
    },
    {
        name: 'clay-400',
        value: 'var(--color-clay-400, #c46d41)',
    },
    {
        name: 'clay-500',
        value: 'var(--color-clay-500, #b24c19)',
    },
    {
        name: 'clay-600',
        value: 'var(--color-clay-600, #9d4316)',
    },
    {
        name: 'clay-700',
        value: 'var(--color-clay-700, #883a13)',
    },
    {
        name: 'clay-800',
        value: 'var(--color-clay-800, #733110)',
    },
    {
        name: 'clay-900',
        value: 'var(--color-clay-900, #5e280d)',
    },
    {
        name: 'forest-100',
        value: 'var(--color-forest-100, #dffbf4)',
    },
    {
        name: 'forest-200',
        value: 'var(--color-forest-200, #a7e2d2)',
    },
    {
        name: 'forest-300',
        value: 'var(--color-forest-300, #60c0a7)',
    },
    {
        name: 'forest-400',
        value: 'var(--color-forest-400, #32a385)',
    },
    {
        name: 'forest-500',
        value: 'var(--color-forest-500, #0f8565)',
    },
    {
        name: 'forest-600',
        value: 'var(--color-forest-600, #0d7256)',
    },
    {
        name: 'forest-700',
        value: 'var(--color-forest-700, #0b5f48)',
    },
    {
        name: 'forest-800',
        value: 'var(--color-forest-800, #094c39)',
    },
    {
        name: 'forest-900',
        value: 'var(--color-forest-900, #07392a)',
    },
    {
        name: 'grass-100',
        value: 'var(--color-grass-100, #e4fbe0)',
    },
    {
        name: 'grass-200',
        value: 'var(--color-grass-200, #b4e8ab)',
    },
    {
        name: 'grass-300',
        value: 'var(--color-grass-300, #7cd06c)',
    },
    {
        name: 'grass-400',
        value: 'var(--color-grass-400, #52bb3e)',
    },
    {
        name: 'grass-500',
        value: 'var(--color-grass-500, #35a51f)',
    },
    {
        name: 'grass-600',
        value: 'var(--color-grass-600, #288b15)',
    },
    {
        name: 'grass-700',
        value: 'var(--color-grass-700, #1d710d)',
    },
    {
        name: 'grass-800',
        value: 'var(--color-grass-800, #145607)',
    },
    {
        name: 'grass-900',
        value: 'var(--color-grass-900, #0c3c02)',
    },
    {
        name: 'ocean-100',
        value: 'var(--color-ocean-100, #dbf9ff)',
    },
    {
        name: 'ocean-200',
        value: 'var(--color-ocean-200, #a5e2ee)',
    },
    {
        name: 'ocean-300',
        value: 'var(--color-ocean-300, #5dc4d8)',
    },
    {
        name: 'ocean-400',
        value: 'var(--color-ocean-400, #2aacc5)',
    },
    {
        name: 'ocean-500',
        value: 'var(--color-ocean-500, #0095b2)',
    },
    {
        name: 'ocean-600',
        value: 'var(--color-ocean-600, #007f97)',
    },
    {
        name: 'ocean-700',
        value: 'var(--color-ocean-700, #00697c)',
    },
    {
        name: 'ocean-800',
        value: 'var(--color-ocean-800, #005262)',
    },
    {
        name: 'ocean-900',
        value: 'var(--color-ocean-900, #003c47)',
    },
    {
        name: 'olive-100',
        value: 'var(--color-olive-100, #f5f9e1)',
    },
    {
        name: 'olive-200',
        value: 'var(--color-olive-200, #d8e1a7)',
    },
    {
        name: 'olive-300',
        value: 'var(--color-olive-300, #b9c86e)',
    },
    {
        name: 'olive-400',
        value: 'var(--color-olive-400, #9eaf42)',
    },
    {
        name: 'olive-500',
        value: 'var(--color-olive-500, #84961e)',
    },
    {
        name: 'olive-600',
        value: 'var(--color-olive-600, #71811a)',
    },
    {
        name: 'olive-700',
        value: 'var(--color-olive-700, #5e6b16)',
    },
    {
        name: 'olive-800',
        value: 'var(--color-olive-800, #4b5611)',
    },
    {
        name: 'olive-900',
        value: 'var(--color-olive-900, #38400d)',
    },
    {
        name: 'raspberry-100',
        value: 'var(--color-raspberry-100, #fbe5ea)',
    },
    {
        name: 'raspberry-200',
        value: 'var(--color-raspberry-200, #f1bbc8)',
    },
    {
        name: 'raspberry-300',
        value: 'var(--color-raspberry-300, #e27a91)',
    },
    {
        name: 'raspberry-400',
        value: 'var(--color-raspberry-400, #d54c6a)',
    },
    {
        name: 'raspberry-500',
        value: 'var(--color-raspberry-500, #c82246)',
    },
    {
        name: 'raspberry-600',
        value: 'var(--color-raspberry-600, #af1e3d)',
    },
    {
        name: 'raspberry-700',
        value: 'var(--color-raspberry-700, #961934)',
    },
    {
        name: 'raspberry-800',
        value: 'var(--color-raspberry-800, #7d152b)',
    },
    {
        name: 'raspberry-900',
        value: 'var(--color-raspberry-900, #641122)',
    },
    {
        name: 'sunset-100',
        value: 'var(--color-sunset-100, #fdede7)',
    },
    {
        name: 'sunset-200',
        value: 'var(--color-sunset-200, #f9cdbd)',
    },
    {
        name: 'sunset-300',
        value: 'var(--color-sunset-300, #f4a68b)',
    },
    {
        name: 'sunset-400',
        value: 'var(--color-sunset-400, #f0845f)',
    },
    {
        name: 'sunset-500',
        value: 'var(--color-sunset-500, #eb6235)',
    },
    {
        name: 'sunset-600',
        value: 'var(--color-sunset-600, #cc5229)',
    },
    {
        name: 'sunset-700',
        value: 'var(--color-sunset-700, #ad431f)',
    },
    {
        name: 'sunset-800',
        value: 'var(--color-sunset-800, #8f3517)',
    },
    {
        name: 'sunset-900',
        value: 'var(--color-sunset-900, #70280f)',
    },
    {
        name: 'yellow-100',
        value: 'var(--color-yellow-100, #fffce5)',
    },
    {
        name: 'yellow-200',
        value: 'var(--color-yellow-200, #fff6bf)',
    },
    {
        name: 'yellow-300',
        value: 'var(--color-yellow-300, #fff095)',
    },
    {
        name: 'yellow-400',
        value: 'var(--color-yellow-400, #ffea6a)',
    },
    {
        name: 'yellow-500',
        value: 'var(--color-yellow-500, #ffe121)',
    },
    {
        name: 'yellow-600',
        value: 'var(--color-yellow-600, #fdce1d)',
    },
    {
        name: 'yellow-700',
        value: 'var(--color-yellow-700, #e2a813)',
    },
    {
        name: 'yellow-800',
        value: 'var(--color-yellow-800, #c8830a)',
    },
    {
        name: 'yellow-900',
        value: 'var(--color-yellow-900, #ad5d00)',
    },
    {
        name: 'green-100',
        value: 'var(--color-green-100, #e5f5ea)',
    },
    {
        name: 'green-200',
        value: 'var(--color-green-200, #b2ecc5)',
    },
    {
        name: 'green-300',
        value: 'var(--color-green-300, #71d994)',
    },
    {
        name: 'green-400',
        value: 'var(--color-green-400, #36c365)',
    },
    {
        name: 'green-500',
        value: 'var(--color-green-500, #10ab44)',
    },
    {
        name: 'green-600',
        value: 'var(--color-green-600, #0c9439)',
    },
    {
        name: 'green-700',
        value: 'var(--color-green-700, #0a7b30)',
    },
    {
        name: 'green-800',
        value: 'var(--color-green-800, #086627)',
    },
    {
        name: 'green-900',
        value: 'var(--color-green-900, #075521)',
    },
    {
        name: 'orange-100',
        value: 'var(--color-orange-100, #fae3d7)',
    },
    {
        name: 'orange-200',
        value: 'var(--color-orange-200, #fac7ae)',
    },
    {
        name: 'orange-300',
        value: 'var(--color-orange-300, #faa67b)',
    },
    {
        name: 'orange-400',
        value: 'var(--color-orange-400, #fa8043)',
    },
    {
        name: 'orange-500',
        value: 'var(--color-orange-500, #f57231)',
    },
    {
        name: 'orange-600',
        value: 'var(--color-orange-600, #e45b17)',
    },
    {
        name: 'orange-700',
        value: 'var(--color-orange-700, #ca4f12)',
    },
    {
        name: 'orange-800',
        value: 'var(--color-orange-800, #aa420e)',
    },
    {
        name: 'orange-900',
        value: 'var(--color-orange-900, #8a350b)',
    },
    {
        name: 'red-100',
        value: 'var(--color-red-100, #fce4e3)',
    },
    {
        name: 'red-200',
        value: 'var(--color-red-200, #f8b9b5)',
    },
    {
        name: 'red-300',
        value: 'var(--color-red-300, #f88078)',
    },
    {
        name: 'red-400',
        value: 'var(--color-red-400, #f4463a)',
    },
    {
        name: 'red-500',
        value: 'var(--color-red-500, #e32619)',
    },
    {
        name: 'red-600',
        value: 'var(--color-red-600, #cf1b0e)',
    },
    {
        name: 'red-700',
        value: 'var(--color-red-700, #ba170b)',
    },
    {
        name: 'red-800',
        value: 'var(--color-red-800, #a4140a)',
    },
    {
        name: 'red-900',
        value: 'var(--color-red-900, #891108)',
    },
    {
        name: 'pink-100',
        value: 'var(--color-pink-100, #fee3ef)',
    },
    {
        name: 'pink-200',
        value: 'var(--color-pink-200, #fdb8d7)',
    },
    {
        name: 'pink-300',
        value: 'var(--color-pink-300, #ff99d0)',
    },
    {
        name: 'pink-400',
        value: 'var(--color-pink-400, #ff66b8)',
    },
    {
        name: 'pink-500',
        value: 'var(--color-pink-500, #ff0089)',
    },
    {
        name: 'pink-600',
        value: 'var(--color-pink-600, #e5007b)',
    },
    {
        name: 'pink-700',
        value: 'var(--color-pink-700, #cc006e)',
    },
    {
        name: 'pink-800',
        value: 'var(--color-pink-800, #ae006b)',
    },
    {
        name: 'pink-900',
        value: 'var(--color-pink-900, #8f0058)',
    },
    {
        name: 'gray-100',
        value: 'var(--color-gray-100, #f5f5f5)',
    },
    {
        name: 'gray-200',
        value: 'var(--color-gray-200, #efefef)',
    },
    {
        name: 'gray-300',
        value: 'var(--color-gray-300, #d4d6d9)',
    },
    {
        name: 'gray-400',
        value: 'var(--color-gray-400, #b9bcc1)',
    },
    {
        name: 'gray-500',
        value: 'var(--color-gray-500, #9ca2ab)',
    },
    {
        name: 'gray-600',
        value: 'var(--color-gray-600, #737e8c)',
    },
    {
        name: 'gray-700',
        value: 'var(--color-gray-700, #626c78)',
    },
    {
        name: 'gray-800',
        value: 'var(--color-gray-800, #36414d)',
    },
    {
        name: 'gray-900',
        value: 'var(--color-gray-900, #1f2830)',
    },
    {
        name: 'gray-950',
        value: 'var(--color-gray-950, #1a1c1e)',
    },
    {
        name: 'black',
        value: 'var(--color-black, #000000)',
    },
    {
        name: 'white',
        value: 'var(--color-white, #ffffff)',
    },
    {
        name: 'neutral-dark-100',
        value: 'var(--color-neutral-dark-100, #090d10)',
    },
    {
        name: 'neutral-dark-200',
        value: 'var(--color-neutral-dark-200, #28292A)',
    },
    {
        name: 'neutral-dark-300',
        value: 'var(--color-neutral-dark-300, #44474B)',
    },
    {
        name: 'neutral-dark-400',
        value: 'var(--color-neutral-dark-400, #61666B)',
    },
    {
        name: 'neutral-dark-500',
        value: 'var(--color-neutral-dark-500, #798086)',
    },
    {
        name: 'neutral-dark-600',
        value: 'var(--color-neutral-dark-600, #94999e)',
    },
    {
        name: 'neutral-dark-700',
        value: 'var(--color-neutral-dark-700, #afb2b6)',
    },
    {
        name: 'neutral-dark-800',
        value: 'var(--color-neutral-dark-800, #caccce)',
    },
    {
        name: 'neutral-dark-900',
        value: 'var(--color-neutral-dark-900, #f2f2f3)',
    },
    {
        name: 'neutral-dark-1000',
        value: 'var(--color-neutral-dark-1000, #ffffff)',
    },
];

export default colors;
